/**
 * AMCパスワード入力画面のサービスクラス
 */
import { Injectable } from '@angular/core';
import { isStringEmpty } from '@common/helper';
import { SupportClass } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services/common-lib/common-lib.service';
import { GetBasicReservationInformationStoreService } from '@lib/services/get-basic-reservation-information-store/get-basic-reservation-information-store.service';
import { GetBasicReservationInformationRequest } from 'src/sdk-amcmember';

@Injectable()
export class PasswordInputService extends SupportClass {
  constructor(
    private _common: CommonLibService,
    private _getBasicReservationInformationService: GetBasicReservationInformationStoreService
  ) {
    super();
  }
  /**
   * パスワード必須チェック
   * @param password パスワード
   * @returns 判定結果 true 失敗
   */
  checkPassword(password: string): boolean {
    if (isStringEmpty(password)) {
      this._common.errorsHandlerService.setRetryableError('subPage', {
        errorMsgId: 'E0001',
        params: { key: 0, value: 'label.password' },
      });
      return true;
    }
    return false;
  }

  /**
   * 予約基本情報取得API呼び出し
   * @param request リクエストパラメータ
   * @returns
   */
  async getBasicReservationInformation(request: GetBasicReservationInformationRequest) {
    this._getBasicReservationInformationService.resetGetBasicReservationInformation();
    this._getBasicReservationInformationService.setGetBasicReservationInformationFromApi(request);
  }

  destroy() {}
}
